import { MARQUEE } from "./data";

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {MARQUEE.map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-display text-4xl sm:text-6xl whitespace-nowrap ${i % 2 ? "italic text-gold" : "text-ivory"}`}>{w}</span>
        <svg viewBox="0 0 10 10" className="w-3 h-3 text-gold/70"><path d="M5 0l1.4 3.6L10 5 6.4 6.4 5 10 3.6 6.4 0 5l3.6-1.4z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative border-y border-gold/20 py-8 overflow-hidden bg-obsidian-2">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
